import React from 'react';
import { Outlet } from 'react-router-dom';
import { useCustomToast } from '../contexts/CustomToastContext';
import CustomToast from '../components/CustomToast';
import Footer from '../components/Footer';
import FilterHeader from '../components/Navbar/FilterHeader';
import SubHeader from '../components/Navbar/SubHeader';
import useMobileScreen from '../hooks/useIsMobile';

const PublicRoutes: React.FC = () => {
  const { message } = useCustomToast();
  const mobile = useMobileScreen();

  return (
    <>
      <FilterHeader />
      <SubHeader />
      {message.text && <CustomToast />}
      <div className="sub-container">
        <div className="sub-container-mob">
          <Outlet />
        </div>
      </div>
      {mobile && <Footer />}
      {!mobile && <Footer />}
    </>
  )
};
export default PublicRoutes;
